import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Portfolio from './components/Portfolio';
// import Blog from './components/Blog';
import Footer from './components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Navbar />
      <Hero />
      <Portfolio />
      {/* <Blog /> */}
      <Footer />
    </div>
  );
};

export default HomePage;
